module.exports = __webpack_public_path__ + "img/image005.a30760ba.jpg";